import React from 'react'
import { useTranslation } from 'react-i18next'
import { createPortal } from 'react-dom'

const DeleteSchoolConfirmModal = ({ isOpen, onClose, onConfirm, isLoading, schoolName }) => {
  const { t } = useTranslation()
  
  if (!isOpen) return null

  const modalContent = (
    <div
      className="fixed inset-0 z-[1100] flex items-center justify-center bg-slate-950/70 px-4 py-10 backdrop-blur-2xl"
      role="dialog"
      aria-modal="true"
      aria-label={t('modals.deleteSchool.ariaLabel')}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose()
        }
      }}
    >
      <div className="pointer-events-none absolute inset-0 bg-brand-radial opacity-50" />

      <div className="relative z-10 w-full max-w-md overflow-hidden rounded-3xl border border-critical/40 bg-surface-raised/90 shadow-elevated-lg">
        <div className="bg-critical/10 px-6 py-4">
          <h2 className="font-display text-xl text-critical">{t('modals.deleteSchool.title')}</h2>
        </div>

        <div className="p-6">
          <div className="mb-6">
            <p className="mb-4 text-sm font-semibold text-white">
              {t('modals.deleteSchool.confirmDeletion')}
            </p>
            {schoolName && (
              <p className="mb-4 text-sm text-muted-300">
                {t('modals.deleteSchool.school')} <span className="font-semibold text-white">{schoolName}</span>
              </p>
            )}
            <p className="text-sm text-muted-400">
              {t('modals.deleteSchool.visibilityHint')} <span className="font-semibold text-muted-300">{t('modals.deleteSchool.visibility')}</span> {t('modals.deleteSchool.left')}
            </p>
            <p className="mt-4 text-xs text-critical">
              {t('modals.deleteSchool.irreversible')}
            </p>
          </div>

          <div className="flex items-center justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={isLoading}
              className="inline-flex items-center gap-2 rounded-xl bg-surface-base/60 px-4 py-2 text-sm font-semibold text-muted-300 transition hover:bg-surface-base/80 hover:text-white disabled:opacity-50"
            >
              {t('modals.deleteSchool.cancel')}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={isLoading}
              className="inline-flex items-center gap-2 rounded-xl bg-critical/20 px-4 py-2 text-sm font-semibold text-critical transition hover:bg-critical/30 hover:shadow-lg hover:shadow-critical/20 disabled:opacity-50"
            >
              {isLoading ? (
                <>
                  <span className="material-icons text-sm animate-spin">refresh</span>
                  {t('modals.deleteSchool.deleting')}
                </>
              ) : (
                <>
                  <span className="material-icons text-sm">delete</span>
                  {t('modals.deleteSchool.deleteSchool')}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  )

  return typeof document !== 'undefined' ? createPortal(modalContent, document.body) : null
}

export default DeleteSchoolConfirmModal



